import logo from './logo.svg';
import './App.css';
import { Link } from "react-router-dom";
import MainRoute from './routers/MainRoute';
import { Routes, Route,useLocation } from "react-router-dom";
import Step1 from "./pages/booking/Step1";
import Step2 from "./pages/booking/Step2";
import Step3 from "./pages/booking/Step3";
import Step4 from "./pages/booking/Step4";
import Step5 from "./pages/booking/Step5";
import Address from "./pages/booking/Address";
import TrackFlight from "./pages/booking/TrackFlight";

import Layout from './layouts/Layout';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import * as bootstrap from "bootstrap";

function App() {
    const location = useLocation();

  // Routes where you don't want Layout (header/footer)
  const noLayoutRoutes = ["/Step1", "/Step2", "/Step3", "/Step4", "/Step5", "/address","/trackflight"];

  // check if current path starts with "/Step1"
  const hideLayout = noLayoutRoutes.some(path =>
    location.pathname.startsWith(path)
  );
  return (
     <div className="">

   {hideLayout ? (
      
        <Routes>
          <Route path="/Step1/:categoryId" element={<Step1 />} />
          <Route path="/step2" element={<Step2 />} />
          <Route path="/step3" element={<Step3 />} />
          <Route path="/step4" element={<Step4 />} />
          <Route path="/step5/:shipmentId" element={<Step5 />} />
          <Route path="/address" element={<Address />} /> 
                <Route path="/trackflight" element={<TrackFlight />} />
                  
        </Routes>
       
      ) : (
        <Layout>
          <MainRoute />
        </Layout>
      )}
   <ToastContainer />
        <a href="https://api.whatsapp.com/send?phone=19853778070" target="_blank" className="whatapp-chat"><img src="images/whatsapp.png" /></a>
       
       { /* Search Box Start Here */}
    <div className="eagle-search-overlay">
        <div className="eagle-icon-close">
            <svg className="qodef-svg--close qodef-m" xmlns="http://www.w3.org/2000/svg" width="28.163" height="28.163" viewBox="0 0 26.163 26.163" >
                <rect width="36" height="1" transform="translate(0.707) rotate(45)"></rect>
                <rect width="36" height="1" transform="translate(0 25.456) rotate(-45)"></rect>
            </svg>
        </div>
        <div className="eagle-search-outer"> 
            <form className="eagle-site-searchform">
                <input type="search" className="form-control field searchform-s" name="s" placeholder="Search …" />
                <button type="submit"></button>
            </form>
        </div>
    </div>
    { /* Search Box End Here */}

    { /* Scroll To Top */}
    { /* <div className="eagle-progress-wrap">
        <svg className="eagle-progress-circle svg-content" width="100%" height="100%" viewBox="-1 -1 102 102">
            <path d="M50,1 a49,49 0 0,1 0,98 a49,49 0 0,1 0,-98"></path>
        </svg>
    </div> */}
    { /* Scroll To Top End */}

    { /* JS
        ============================================ */}
   
  </div>
  );
}

export default App;
